import { cn } from '../../lib/utils';

interface GradientBorderProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  /** Whether the border is visible. Use for animated reveal. */
  visible?: boolean;
}

/**
 * GradientBorder - A container with a gradient border effect
 *
 * Uses a 1px padding trick with gradient background to create a border
 * that fades from top-left to bottom-right.
 */
export function GradientBorder({
  children,
  className,
  innerClassName,
  visible = true,
  ...props
}: GradientBorderProps) {
  return (
    <div
      className={cn(
        'rounded-xl p-[1px] transition-all duration-300',
        visible
          ? 'bg-gradient-to-br from-white/25 via-white/10 to-white/5'
          : 'bg-transparent',
        className,
      )}
      {...props}
    >
      <div className={cn('rounded-[11px] bg-neutral-900', innerClassName)}>
        {children}
      </div>
    </div>
  );
}
